import React from 'react'
import { toast } from "react-toastify"
import { HiOutlineLogout } from 'react-icons/hi'
import { useHistory } from 'react-router-dom'

const LogoutView = ({closeModal}) => {

    // history object
    const history = useHistory()

    // // dispatch object
    // const dispatch = useDispatch()

    // // handle account deletion
    // const onLogout = () => {
    //     closeModal()
    //     dispatch(logout())
    //     history.push("/login")
    // }

    // handle deletion cancel
    const onCancelLogout = () => {
        closeModal()
    }

    return (
        <div className="p-5 py-7 mobile:p-4 bg-white flex flex-col gap-4 items-center">
            
            {/* icon container */}
            <div>
                <HiOutlineLogout color='#E02D3C' size={32} />
            </div>

            {/* text container */}
            <div>
                <p className='text-base font-semibold text-[#111827]'>
                    Are you sure you want to Logout?
                </p>
            </div>

            {/* buttons container */}
            <div className='flex w-full mobile:flex-col mobile:justify-center mobile:items-stretch justify-between items-center gap-4 mt-5 mobile:mt-2'>

                <button 
                onClick={onCancelLogout}
                className='border border-[#D1D5DB] px-4 py-2 text-[#374151] font-medium text-base rounded-[6px] hover:bg-[#f5f5f5] bg-white inline-flex items-center justify-center w-full'>
                    No
                </button>

                <button
                onClick={()=>history.push("/")} 
                className='border border-[#E02D3C] px-4 py-2 font-medium text-base rounded-[6px] hover:opacity-70 bg-[#E02D3C] text-white inline-flex items-center justify-center w-full'>
                    Yes
                </button>
            </div>
        </div>
    )
}

export default LogoutView